// Republic Atlas - Development Banner Component
// Shows a banner when in development mode or preview deployment

import { useState } from 'react';

export function DevBanner() {
  const [isVisible, setIsVisible] = useState(true);
  
  // Only show in development or if URL contains preview
  const isDev = import.meta.env.DEV;
  const isPreview = typeof window !== 'undefined' && 
    (window.location.hostname.includes('--preview') || 
     window.location.hostname.includes('localhost'));
  
  if (!isDev && !isPreview) return null;
  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white text-sm">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
          <span className="font-medium">
            {isDev ? '🛠️ Development Mode' : '👁️ Preview Deployment'}
          </span>
          <span className="hidden sm:inline text-amber-100">
            — Some features may not work as expected
          </span>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="p-1 hover:bg-white/20 rounded transition-colors"
          aria-label="Dismiss"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default DevBanner;

